import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Box, Flex, Text, useMediaQuery, useTheme } from '@chakra-ui/react';
import PropTypes from 'prop-types';

const FormField = ({
  label,
  children,
  isVertical,
  hasError,
  className = '',
}) => {
  const theme = useTheme();
  const [isDesktop] = useMediaQuery(`(min-width: ${theme.breakpoints.md})`);
  const styles = useMemo(
    () => ({
      container: {
        ...(isVertical || !isDesktop
          ? { flexDirection: 'column', alignItems: 'stretch' }
          : {
              flexDirection: 'row',
              alignItems: 'stretch',
              minHeight: '44px',
            }),
      },
      labelWrapper: {
        textAlign: 'left',
        ...(isVertical || !isDesktop
          ? { paddingBottom: '10px', width: '100%' }
          : {
              paddingRight: '20px',
              paddingTop: '12px',
              width: '149px',
              minHeight: '44px',
            }),
      },
      childrenWrapper: isVertical ? {} : { flex: '1' },
    }),
    [isVertical, isDesktop],
  );

  return (
    <Flex {...styles.container} className={classNames('form_field', className)}>
      <Box {...styles.labelWrapper}>
        {typeof label === 'string' ? (
          <Text
            variant={hasError ? 'errorMessage' : 'formLabel'}
            fontSize="14px"
            className="member-center-profile__label"
          >
            {label}
          </Text>
        ) : (
          label
        )}
      </Box>
      <Flex
        direction="column"
        gap="0.3125rem"
        alignItems="stretch"
        className="form-field_content"
        {...styles.childrenWrapper}
      >
        {children}
      </Flex>
    </Flex>
  );
};

FormField.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  isVertical: PropTypes.bool,
  hasError: PropTypes.bool,
  className: PropTypes.string,
};

export default FormField;
